import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { Link } from "react-router-dom";
import useFormValidationSignup from "../../Hooks/SignupHook";
import { PiEyeSlashThin } from "react-icons/pi";
import { PiEyeThin } from "react-icons/pi";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import { useNavigate } from "react-router-dom";
import "./Signup.css";

const Signup = () => {
  const {
    formData,
    errors,
    resDataError,
    isLoading,
    handleInputChange,
    handleSubmit,
    handleShow,
    show,
    handleShow2,
    show2
  } = useFormValidationSignup();
  const {userType} = useContext(AuthContext)
  const navigate = useNavigate()

  return (
    <div className="signeup-account">
      <div className="content-card">
      <div className="wrap">
        <BlackVatugIcon onClick={() => navigate("/")}/>
        <Link to="/ChooseAccount" >Back</Link>
        </div>
        <form onSubmit={handleSubmit}>
        <h3>Create account</h3>
        <p>For {userType}</p>
          <label>
            <input
              type="email"
              placeholder="Enter Email address"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </label>

          <label>
            <span>
              <input
                type={show ? "text" : "password"}
                placeholder="Enter Password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
              />

              {
                show ? <PiEyeSlashThin onClick={handleShow} /> : <PiEyeThin onClick={handleShow} />
              }
           
              
            </span>
            {errors.password && (
              <p className="error">
                {Array.isArray(errors.password)
                  ? errors.password[0]
                  : errors.password}
              </p>
            )}
          </label>
          <label>
            <span>
              <input
                type={show2 ? "text" : "password"}
                placeholder="Confirm Password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleInputChange}
              />
             {
                show2 ? <PiEyeSlashThin onClick={handleShow2} /> : <PiEyeThin onClick={handleShow2} />
              }
            </span>
            {errors.confirmPassword && <p className="error">{errors.confirmPassword}</p>}
          </label>

          {resDataError && <p className="error">{resDataError}</p>}

          <button type="submit" disabled={isLoading}>
            {isLoading ? "authenticating...." : "Continue"}
          </button>

          <div className="agree">
            <p>
              By continuing, you agree to vatug's{" "}
              <a href="/">Terms of Service</a> and{" "}
              <a href="/">Privacy Policy</a>
            </p>
            <span>
              Already have an account? <Link to="/Login">Log In</Link>
            </span>
          </div>
        </form>
      </div>
      <div className="img"></div>
    </div>
  );
};

export default Signup;
